import { ColorsPalette } from '@casavo/base-ui/types/foundations/colors'

import { SvgProps } from '@/components/Icon'
import BaseSvg from '@/components/Icon/BaseSvg'
import { theme } from '@/design-lib/theme'

interface Props extends SvgProps {
  ellipseColor: ColorsPalette
}

const BellNotification: React.FC<Props> = ({ className, ellipseColor }) => {
  return (
    <BaseSvg className={className} height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M0.000522296 22H3V14.5C3 10.5109 5.59531 7.12792 9.18953 5.94751C9.6153 4.81041 10.713 4 12 4C13.2865 4 14.3839 4.80985 14.8102 5.94758C18.404 7.12698 21 10.5103 21 14.5V22H23.9995L24 25L16.2435 25.0014C15.989 25.7205 15.557 26.3557 15 26.8542C14.2039 27.5667 13.1525 28 12 28C10.8475 28 9.79613 27.5667 9 26.8542C8.44304 26.3557 8.01097 25.7205 7.75654 25.0014L0 25L0.000522296 22ZM6.00734 14.2005L6 14.5V22H18V14.5C18 11.2867 15.474 8.66338 12.2995 8.50734L12 8.5C8.78671 8.5 6.16338 11.026 6.00734 14.2005Z"
        fillRule="evenodd"
      />
      <ellipse cx="22" cy="6.99984" fill={theme.colors[ellipseColor]} rx="6" ry="5.83333" />
    </BaseSvg>
  )
}

export default BellNotification
